import type { Dispatch, ReactNode, SetStateAction } from 'react';
import type { ReportNumberOfEmployeeMonthMetric } from '@/common/graphql';
import type { FilterProps } from '@/common/hooks/shared/useFilters';
import type { NumberOfEmployeesFilterType } from '@/common/types';

export interface NumberOfEmployeesTableProps<T extends { [key: string]: any } = {}> {
  disabled: boolean;
  filters?: FilterProps<NumberOfEmployeesFilterType>;
  moreFilters?: FilterProps<T>;
  setDisabled: Dispatch<SetStateAction<boolean>>;
}

export interface NumberOfEmployeesTableWithFilterProps<T extends { [key: string]: any } = {}>
  extends NumberOfEmployeesTableProps<T> {
  filters: FilterProps<NumberOfEmployeesFilterType>;
  moreFilters: FilterProps<T> | undefined;
}

export type ClientReportNumberOfEmployeeMetric = { [yearMonth: string]: string };

export interface ReportNumberOfEmployee<T extends ReportNumberOfEmployeeItem> {
  yearMonthList: Array<string>;
  allIds: Array<string>;
  maxDepth: number;
  items: Array<T>;
  total: Array<ReportNumberOfEmployeeMonthMetric>;
}

export interface ReportNumberOfEmployeeItem {
  id: string;
  dimension: any;
  metrics: Array<ReportNumberOfEmployeeMonthMetric>;
  children?: Array<ReportNumberOfEmployeeItem>;
}

export interface ClientReportNumberOfEmployeeItem {
  id: string;
  dimension: ReactNode;
  dimensionText?: string;
  metrics: ClientReportNumberOfEmployeeMetric;
  children: Array<ClientReportNumberOfEmployeeItem> | null;
}

export interface ColumnComputationResult {
  columnList: Array<string>;
  sumByYearMonth: Array<[string, string]>;
  isCurrentColumn: (key: string) => boolean;
}

export interface ColumnDataProps {
  renderer: (result: ColumnComputationResult) => ReactNode;
}
